import React, { Component } from "react";
import PlumProBox from "../../../components/Cards/PlumProBox";
import { getCloudinaryUrl } from "../../../config/cloudinary";
import {
  Button,
  Card,
  Icon,
  Tag,
  Typography,
  Modal,
  Loaders,
  CircularLoader,
  Tooltip,
  Chip,
} from "@plum-xoxo/admin-dsm";
import config from "config";
import { CopyToClipboard } from "react-copy-to-clipboard";
import styled from "styled-components";
const StyledBorderBottom = styled.div`
  border-bottom: 1px solid ${(props) => props.theme.palette.light.c300};
`;

const StyledBorderTop = styled.div`
  border-top: 1px solid ${(props) => props.theme.palette.light.c300};
  background-color: ${(props) => props.theme.palette.light.c000};
`;
class AutomationCampaignDetailsModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      xoxoCodeChipTooltip: false,
    };
  }

  handleCampaignDetailsModalClose = () => {
    this.props.toggleAutomationCampaignDetailsModal();
  };

  editCampaign = () => {
    this.props.editCampaign();
  };

  render() {
    const {
      campaignDetails,
      showAutomationCampaignDetailsModal,
      loader = false,
    } = this.props;
    const isMerchandiseCampaign = campaignDetails?.filter_group_id === config?.merchdiseFilterGroupId
    return (
      <Modal
        isOpen={showAutomationCampaignDetailsModal}
        onClose={() => {
          this.handleCampaignDetailsModalClose();
        }}
        //size="lg"
        fullScreen={true}
        disableCloseButton={false}
      >
        <div className="overflow-hidden">
          <Typography.H2 className="mb-lg-3">
            {campaignDetails?.campaignName}
          </Typography.H2>
          <StyledBorderBottom className="col mb-md-4"></StyledBorderBottom>
          {!loader ? (
            <>
              <div className="d-flex mb-md-4">
                <div>
                  <Chip
                    color="primary"
                    radius={40}
                    size="medium"
                    label={
                      <div className="d-flex align-items-center">
                        <Typography
                          className="mr-2 mb-0"
                          color="dark"
                          shade="c200"
                        >
                          Country
                        </Typography>
                        <Typography className="mb-0" color="dark" shade="c300">
                          {campaignDetails?.countryName}
                        </Typography>
                      </div>
                    }
                  />
                  <Chip
                    className="mx-12"
                    color="primary"
                    radius={40}
                    size="medium"
                    label={
                      <div className="d-flex align-items-center">
                        <Typography
                          className="mr-2 mb-0"
                          color="dark"
                          shade="c200"
                        >
                          Total {isMerchandiseCampaign ? "Products" : "Brands"} 
                        </Typography>
                        <Typography className="mb-0" color="dark" shade="c300">
                          {" "} {campaignDetails?.vouchers?.length}
                        </Typography>
                      </div>
                    }
                  />
                  <Chip
                    color="primary"
                    radius={40}
                    size="medium"
                    label={
                      <div className="d-flex align-items-center">
                        <Typography
                          className="mr-2 mb-0"
                          color="dark"
                          shade="c200"
                        >
                          {isMerchandiseCampaign ? "Budget" : "Denomination"}  
                        </Typography>
                        <Typography className="mb-0" color="dark" shade="c300">
                          {" "}  {campaignDetails?.currency_code}{" "}
                          {campaignDetails?.denomination_value}
                        </Typography>
                      </div>
                    }
                  />
                  {campaignDetails?.xc_support == 1 ? (
                    <Tooltip
                      tooltip="Global voucher with over 2000+ brand
  across 70+ countries"
                    >
                      <Chip
                        className="follow-steps pt-3 pb-3 rounded-pill ml-6"
                        color="primary"
                        variant="status"
                        id="xoxocode-tag"
                        label={
                          <div className="d-flex align-items-center">
                            <Typography
                              className="mr-2 mb-0"
                              color="dark"
                              shade="c200"
                            >
                              Xoxo code
                            </Typography>
                          </div>
                        }
                      />
                    </Tooltip>
                  ) : null}
                </div>
              </div>
              <div className="row mb-72 mt-20">
                {campaignDetails?.vouchers?.length > 0 ? (
                  campaignDetails.vouchers.map((v, i) => {
                    let imageUrl = getCloudinaryUrl(v.image);
                    return (
                      <div className="col-2">
                        <PlumProBox
                          classname={"voucher-card-campaign"}
                          voucherUrl={imageUrl}
                          name={v.name}
                          cardId={i}
                          imageClass={"lbr-selected-image"}
                          cardTextClass={"mb-2 mt-12"}
                        />
                      </div>
                    );
                  })
                ) : campaignDetails?.xc_support == 1 ? (
                  <div className="col-md-2">
                    <PlumProBox
                      classname={"voucher-card-campaign"}
                      voucherUrl="https://res.cloudinary.com/dyyjph6kx/image/upload/v1634815818/gift_vouchers/xoxo-code.jpg"
                      name="Xoxo Code"
                      cardId={0}
                      imageClass={"lbr-selected-image"}
                      cardTextClass={"mb-2 mt-12"}
                    />
                  </div>
                ) : null}
              </div>
              <StyledBorderTop className="d-flex justify-content-end fixed-bottom py-20 px-52">
                {campaignDetails?.isEditable ? (
                  <Button
                    onClick={() => this.editCampaign()}
                    variant="outlined"
                    color="primary"
                    className=""
                  >
                    Edit Campaign
                  </Button>
                ) : null}
              </StyledBorderTop>
            </>
          ) : (
            <CircularLoader size="lg" vertical center />
          )}
        </div>
      </Modal>
    );
  }
}
export default AutomationCampaignDetailsModal;
